// extracted by mini-css-extract-plugin
module.exports = {"fusion":"_4f96e25"};